// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "593d34f",
    "hash": "593d34f",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "593d34f",
    "semverString": null,
    "version": "2.3.5"
};
/* tslint:enable */
